import { JournalEntryCategories } from './Constants';

export const FILTER_DEFINITIONS = [
    {
        label: 'Mandanten-Objekte',
        options: [
            { value: JournalEntryCategories.CHANGE_RECORD, label: 'Mandanten-Objekte anzeigen' },
        ]
    },
    {
        label: 'Alarmstufen',
        options: [{ value: JournalEntryCategories.ALARMLEVEL_SET, label: 'Alarmstufen-Änderungen' },]
    },
    {
        label: 'Maßnahmenplan',
        options: [
            { value: JournalEntryCategories.OPERATION_PLANNING, label: 'Maßnahmenplanung' },
            { value: JournalEntryCategories.ACTIVATION_MATRIX, label: 'Auslösematrix' },
            { value: JournalEntryCategories.TASK_MANAGEMENT, label: 'Maßnahmenausführung' },
        ]
    },
    {
        label: 'Lagemeldung',
        options: [
            { value: JournalEntryCategories.SITUATION_MESSAGE, label: 'Lagemeldungen' },
        ]
    },
    {
        label: 'Manuelle Journaleinträge',
        options: [
            {
                value: [JournalEntryCategories.ALARMLEVEL_MANUAL, JournalEntryCategories.WATERLEVEL_MESSAGE, JournalEntryCategories.WEATHER_WARNING, JournalEntryCategories.WATER_LEVEL_CHART, JournalEntryCategories.PRECIPITATION_STATION_CHART, JournalEntryCategories.FRB_CHART, JournalEntryCategories.WEBCAM, JournalEntryCategories.REAL_PRECIPITATION_STATION_CHART],
                label: 'Alle anzeigen'
            },
            { value: JournalEntryCategories.ALARMLEVEL_MANUAL, label: 'Alarmstufen anderer Mandanten' },
            { value: JournalEntryCategories.WATERLEVEL_MESSAGE, label: 'Wasserstandsmeldungen' },
            { value: JournalEntryCategories.WEATHER_WARNING, label: 'Wetterwarnungen' },
            { value: JournalEntryCategories.WATER_LEVEL_CHART, label: 'Pegeldiagramme' },
            { value: JournalEntryCategories.PRECIPITATION_STATION_CHART, label: 'Radar Niederschlagsmessung' },
            { value: JournalEntryCategories.REAL_PRECIPITATION_STATION_CHART, label: 'Niederschlagsmessstation' },
            { value: JournalEntryCategories.FRB_CHART, label: 'HRB-Diagramme' },
            { value: JournalEntryCategories.WEBCAM, label: 'Inhalt von Webcam-Kachel' },
        ]
    },
    {
        label: 'Lagekarte',
        options: [
            { value: 'SITUATION_MAP', label: 'Lagekarte' },
        ]
    }
];



// WEBPACK FOOTER //
// ./js/constants/FilterDefinitions.js